// extracted by mini-css-extract-plugin
export default {"clickableCard":"jut__ClickableCard__clickableCard","disabled":"jut__ClickableCard__disabled","activeKeypress":"jut__ClickableCard__activeKeypress"};